'use client';

import LinkButton from '@umodeapporg/ui/components/Navigation/LinkButton';
import { MaterialSymbol } from '@umodeapporg/ui/components/UI/MaterialSymbol';
import { useTranslation } from 'react-i18next';

import { IMPLANTACAO_ABERTA, IMPLANTACAO_PARAM } from '@/domain/implantacao/helpers/implantacaoItens';
import { cn } from '@/lib/utils';

/** A lista que mostra item por item o que falta validar, já aberta. */
const IMPLANTACAO_HREF = `/settings?${IMPLANTACAO_PARAM}=${IMPLANTACAO_ABERTA}`;

interface HomeImplantacaoLinhaProps {
  /** Quantos itens ainda pedem validação; zero tira a linha da tela. */
  total: number;
  /** A leitura ainda não voltou, ou falhou: a linha não dá notícia que não tem. */
  silenciar: boolean;
  className?: string;
}

/**
 * Uma LINHA, não um cartão: o que falta validar é tarefa de implantação, e ela agora
 * mora inteira na faixa de Implantação das Configurações.
 *
 * Na Início ela ocupava a primeira dobra com uma fila de atalhos que repetia, item por
 * item, a mesma lista daquela aba. Quem abre a Início de manhã quer o que fazer HOJE na
 * produção; a implantação acontece uma vez e some. Sobra o tamanho dela e o caminho.
 */
export function HomeImplantacaoLinha({ total, silenciar, className }: HomeImplantacaoLinhaProps) {
  const { t } = useTranslation('common');

  if (silenciar || total <= 0) {
    return null;
  }

  return (
    <p className={cn('flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-foreground-muted', className)}>
      <MaterialSymbol icon="checklist" size={16} className="shrink-0 text-foreground-subtle" aria-hidden />
      {t('home.implantacao.linha', { count: total })}
      <LinkButton href={IMPLANTACAO_HREF} variant="text" tone="brand" size="sm" className="normal-case">
        {t('home.implantacao.abrir')}
        <MaterialSymbol icon="arrow_forward" size={16} />
      </LinkButton>
    </p>
  );
}
